import { makeStyles } from 'tss-react/mui'

export default makeStyles()(theme => ({
  wrapper: {
    position: 'relative',
    zIndex: '5',
    minHeight: '100%',
  },
  container: {
    maxWidth: '100vw',
    boxSizing: 'border-box',
    display: 'flex',
    justifyContent: 'flex-end',
    minHeight: '100%',
    position: 'relative',
  },
  content: {
    width: '100%',
  },
  sticky: {
    '& > *': {
      position: 'sticky',
      top: 0,
    },
  },
}))
